define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Util, Constants, Component) => {

  const { classNames } = Util;

  @Component()
  class GridColumn extends React.Component {
    static propTypes = {
      components: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    };

    renderChildComponents() {
      const { childComponents, renderComponent } = this.props;

      return childComponents.map(renderComponent);
    }

    render() {
      const { contentAlign = 'center' } = this.props;
      const className = `sumome-wysiwyg-gridColumn-contents sumome-react-wysiwyg-content-align-${contentAlign}`;
      const gridColumnStyle = {
        position: 'absolute',
        top: '0px',
        left: '0px',
        bottom: '0px',
        right: '0px',
      };


      return (
        <div className={className} style={gridColumnStyle}>
          {this.renderChildComponents()}
        </div>
      );
    }
  }

  return GridColumn;
});
